module.exports = __webpack_public_path__ + "img/sparkles-bg-mob-bottom.77c728e.svg";